import React, { PropTypes } from 'react';
import { withRouter } from 'react-router';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import { userIdentityShape } from '@bibliocommons/bc-prop-types';
import { UserHeader, UserHeaderNav } from '@bibliocommons/user-header';
import { Shelves } from '@bibliocommons/base-icons';
import { Dropdown } from '@bibliocommons/base-dropdown';
import BcReactComponent from '@bibliocommons/base-bc-react-component';

import { SUMMARY_ORDER } from '../../../constants/ShelfConstants';
import './ShelfHeader.scss';

export class ShelfHeader extends BcReactComponent {
  getNavItems() {
    const { currentShelfName, summary, params } = this.props;
    const orderedSummary = summary.get('shelves').sortBy(shelf => SUMMARY_ORDER.indexOf(shelf.get('name')));

    return orderedSummary.map(shelf => {
      const shelfName = shelf.get('name');
      const label = shelf.get('label') || (<FormattedMessage id={`label_${shelfName}_shelf`} />);
      const basePath = params.userId ? `/v2/users/${params.userId}/shelves` : '/v2/shelves';

      return Immutable.Map({
        key: `shelf_${shelfName}`,
        label: <span className="nav-item-label">{label} ({shelf.get('count')})</span>,
        link: `${basePath}/${shelfName}`,
        value: `${basePath}/${shelfName}`,
        active: shelfName === currentShelfName
      });
    });
  }

  renderNav(navItems) {
    const { owner } = this.props;
    const heading = owner.get('loggedIn') ? 'section_title_my_shelves' : 'section_title_shelves';

    return (
      <UserHeaderNav
        renderHeading={() => <FormattedMessage id={heading} />}
        renderIcon={() => <Shelves />}
        isCurrentUser={owner.get('loggedIn')}
        items={navItems}
        userIdentity={owner} />
    );
  }

  renderMobileNav(navItems) {
    const currentShelf = navItems.find(item => item.get('active'));

    return (
      <span className="shelf-mobile-nav visible-xs">
        <Dropdown
          disableMobile
          selected={currentShelf.get('label')}
          options={navItems.toJS()}
          handleSelect={(href) => this.props.router.push(href)}
          className="btn-link" />
      </span>
    );
  }

  renderUserHeader(navItems) {
    return !this.context.mobileApp ? <UserHeader userIdentity={this.props.owner} renderNav={() => this.renderNav(navItems)} /> : null;
  }

  render() {
    const navItems = this.getNavItems();

    return (
      <div className="cp-shelf-header">
        {this.renderUserHeader(navItems)}
        {this.renderMobileNav(navItems)}
      </div>
    );
  }
}

ShelfHeader.propTypes = {
  currentShelfName: PropTypes.string.isRequired,
  owner: userIdentityShape.isRequired,
  summary: ImmutablePropTypes.contains({
    shelves: ImmutablePropTypes.list.isRequired
  }).isRequired
};

ShelfHeader.contextTypes = {
  mobileApp: PropTypes.bool
};

export default withRouter(ShelfHeader);



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfHeader/ShelfHeader.jsx